import { render } from "./TrackMedicalApplication.vue?vue&type=template&id=8bd67fe4&scoped=true"
import script from "./TrackMedicalApplication.vue?vue&type=script&lang=js"
export * from "./TrackMedicalApplication.vue?vue&type=script&lang=js"

import "./TrackMedicalApplication.vue?vue&type=style&index=0&id=8bd67fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd67fe4"]])

export default __exports__